import React, { useEffect, useState } from "react";
import FullLogo from "./FullLogo";

/**
 * Minimal cinematic intro splash:
 * - shows the full Golden Elia logo on a black scene for ~3 seconds
 * - gold radial glow + soft scale-in animation
 * - automatically fades out and reveals the site
 * - shows once per session (sessionStorage flag)
 */
export const IntroOverlay = () => {
  const [stage, setStage] = useState("show"); // show | leaving | done

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem("goldenelia-intro-shown")) {
      setStage("done");
      return;
    }
    const fadeT = setTimeout(() => setStage("leaving"), 3000);
    const doneT = setTimeout(() => {
      setStage("done");
      sessionStorage.setItem("goldenelia-intro-shown", "1");
    }, 4100);
    return () => {
      clearTimeout(fadeT);
      clearTimeout(doneT);
    };
  }, []);

  if (stage === "done") return null;

  return (
    <div
      data-testid="intro-overlay"
      aria-hidden="true"
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black overflow-hidden"
      style={{
        opacity: stage === "leaving" ? 0 : 1,
        pointerEvents: stage === "leaving" ? "none" : "auto",
        transition: "opacity 1.1s cubic-bezier(0.65, 0, 0.35, 1)",
      }}
    >
      {/* Gold radial glow */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 700px 600px at 50% 50%, rgba(201,169,97,0.22), transparent 70%)",
        }}
      />

      {/* Brand mark */}
      <div
        className="relative z-10"
        style={{
          opacity: stage === "leaving" ? 0.9 : 1,
          transform: stage === "leaving" ? "scale(1.04)" : "scale(1)",
          transition:
            "transform 2.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 1.2s ease",
          animation: "goldeneliaIntroIn 1.6s cubic-bezier(0.22, 1, 0.36, 1) both",
        }}
      >
        <FullLogo size={420} testid="intro-full-logo" />
      </div>

      {/* Hairlines */}
      <div className="pointer-events-none absolute inset-x-12 top-12 h-px bg-gradient-to-r from-transparent via-[var(--goldenelia-gold)] to-transparent opacity-60 z-10" />
      <div className="pointer-events-none absolute inset-x-12 bottom-12 h-px bg-gradient-to-r from-transparent via-[var(--goldenelia-gold)] to-transparent opacity-60 z-10" />

      <style>{`
        @keyframes goldeneliaIntroIn {
          0%   { opacity: 0; transform: scale(0.96); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default IntroOverlay;
